import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

function DefaultEmptyComponent() {
  return (
    <Col className="pt-5 d-flex justify-content-center align-items-center">
      <Button variant="primary" size="md" disabled>
        Não há itens a serem exibidos
      </Button>
    </Col>
  );
}

export function DefaultLoadingComponent() {
  return (
    <Col className="pt-5 d-flex justify-content-center align-items-center">
      <Button variant="secondary" size="md" disabled>
        <Spinner animation="border" role="status" /> Carregando
      </Button>
    </Col>
  );
}

function List({
  data,
  loading,
  renderItem,
  EmptyComponent = DefaultEmptyComponent,
  LoadingComponent = DefaultLoadingComponent,
}) {
  const display = data.length ? data.map(renderItem) : <EmptyComponent />;
  return <Row>{loading ? <LoadingComponent /> : display}</Row>;
}

export default List;
